<template>
  <div class="groupImg2">
    <div class="width1000">
      <div class="title">

        <p>
          {{dataList.mainTitle}}
        </p>

      </div>
      <div class="picList">

        <swiper :options="swiperOption"
                ref="mySwiper"
                @someSwiperEvent="callback">
          <!-- slides -->
          <swiper-slide v-for="(item,index) in dataList.data"
                        :key="index">
            <div class="pic-item">
              <div class="container">
                <!-- <a :href="item.url"><img :src="item.imgUrl">
                  <p>
                    <center>{{item.title}}</center>
                    {{item.content}}
                  </p>
                </a> -->
                <a v-if="item.dataType=='article'"
                   class="linkImg"
                   :href="'/h5/detail.html?artId='+item.dataVal"
                   target="_blank ">
                  <img :src="item.imgUrl">
                  <p style="padding:0 10px">
                    <center>{{item.title}}</center>
                    {{item.description}}
                  </p>
                </a>
                <a v-else
                   class="linkImg"
                   :href="item.dataVal"
                   target="_blank ">
                  <img :src="item.imgUrl">
                  <p>
                    <center>{{item.title}}</center>
                    {{item.description}}
                  </p>
                </a>
              </div>
            </div>
          </swiper-slide>

          <!-- Optional controls -->

          <div class="swiper-button-prev"
               slot="button-prev"></div>
          <div class="swiper-button-next"
               slot="button-next"></div>

        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      newData: [],
      swiperOption: {
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        slidesPerView: 3,
        spaceBetween: 0,


      }
    }
  },
  props: ['dataList'],
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {


  },
  methods: {

    callback () { }
  },
  watch: {
    dataList (val) {

      this.dataList = val;
    }
  }
}
</script>

<style lang="less">
.groupImg2 {
  margin-top: 30px;
  .swiper-container {
    height: 242px;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url('../../assets/images/picArrow_r.png');
    background-size: 30px 30px;
    top: 80px;
    right: 20px;
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url('../../assets/images/picArrow_l.png');
    left: 15px;
    background-size: 30px 30px;
    top: 80px;
  }
  .el-carousel__arrow {
    background-color: rgba(0, 0, 0, 0.6);
  }
  .el-carousel__arrow--right {
    right: 4px;
    top: 50%;
    margin-top: -36px;
  }
  .el-carousel__arrow--left {
    left: 4px;
    top: 50%;
    margin-top: -36px;
  }

  // margin-top: -10px;
  .title {
    height: 30px;
    line-height: 30px;
    // border-bottom: 1px solid #c9dff4;
    font-weight: normal;
    a:hover {
      color: #e60012;
    }

    p {
      display: inline-block;
      height: 30px;
      font-size: 24px;
      // padding-left: 10px;
      color: #000;
      // border-bottom: 4px solid #0276da;
    }
  }
  .picList {
    height: 242px;
    font: normal 12px/180% '宋体';
    .pic-item {
      width: 100%;
      padding-top: 10px;
      height: 242px;
      // float: left;

      .container {
        width: 94%;
        height: 100%;
        margin: 0 auto;
        .linkImg {
          width: 100%;
          display: block;
          img {
            width: 100%;
            height: 150px;
          }
        }

        a {
          display: inline-block;
          height: 242px;
          background: #f8f8f8;
        }
        a:hover {
        }
        p:hover {
          color: #e60012;
        }
        p {
          margin-top: 10px;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>
